import { render, staticRenderFns } from "./LabourRateDetail.vue?vue&type=template&id=aad5ea50"
import script from "./LabourRateDetail.vue?vue&type=script&lang=ts"
export * from "./LabourRateDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports